interface PurchaseInfoProps {
  formData: any;
  updateFormData: (field: string, value: string) => void;
}

export default function PurchaseInfo({ formData, updateFormData }: PurchaseInfoProps) {
  return (
    <section className="bg-white rounded-xl shadow-sm p-6">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 bg-amber-100 rounded-lg flex items-center justify-center">
          <i className="ri-home-4-line text-amber-600 text-xl"></i>
        </div>
        <h2 className="text-xl font-semibold text-slate-800">Konut Satın Alma</h2>
      </div>

      <div className="space-y-5">
        {/* Konut Satın Alma Nedeni */}
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-3">
            Konut Satın Alma Nedeniniz?
          </label>
          <div className="space-y-3">
            <label className="flex items-center gap-3 p-4 border border-slate-300 rounded-lg hover:bg-slate-50 transition-colors cursor-pointer">
              <input
                type="radio"
                name="purchaseReason"
                value="Yatırım"
                checked={formData.purchaseReason === 'Yatırım'}
                onChange={(e) => updateFormData('purchaseReason', e.target.value)}
                className="w-4 h-4 text-emerald-600 cursor-pointer"
              />
              <span className="text-sm text-slate-700">Yatırım</span>
            </label>
            <label className="flex items-center gap-3 p-4 border border-slate-300 rounded-lg hover:bg-slate-50 transition-colors cursor-pointer">
              <input
                type="radio"
                name="purchaseReason"
                value="Yatırım-Oturum"
                checked={formData.purchaseReason === 'Yatırım-Oturum'}
                onChange={(e) => updateFormData('purchaseReason', e.target.value)}
                className="w-4 h-4 text-emerald-600 cursor-pointer"
              />
              <span className="text-sm text-slate-700">Yatırım-Oturum</span>
            </label>
            <label className="flex items-center gap-3 p-4 border border-slate-300 rounded-lg hover:bg-slate-50 transition-colors cursor-pointer">
              <input
                type="radio"
                name="purchaseReason"
                value="Mevcut Konutu Yenilemek İçin"
                checked={formData.purchaseReason === 'Mevcut Konutu Yenilemek İçin'}
                onChange={(e) => updateFormData('purchaseReason', e.target.value)}
                className="w-4 h-4 text-emerald-600 cursor-pointer"
              />
              <span className="text-sm text-slate-700">Mevcut Konutu Yenilemek İçin</span>
            </label>
          </div>
        </div>
      </div>
    </section>
  );
}
